module.exports = __webpack_public_path__ + "static/media/cozy9108.2c90ea29.jpg";